/* Bellori × Loox — page « Nos avis » : filtres/tri/load-more sur les avis rendus
   côté serveur (feed Loox), lightbox photos, scroll vers #ecrire, préselection ?product=. */
(function () {
  'use strict';
  var root = document.querySelector('[data-avis]');
  if (!root) return;

  var grid = root.querySelector('[data-review-grid]');
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-review]'));
  var pageSize = 9;
  var filter = 'all', sort = 'recent';

  /* ?product=handle → présélectionne le modèle */
  try {
    var q = new URLSearchParams(window.location.search);
    var pr = q.get('product');
    if (pr) {
      var map = { rond: 'geneve', gen: 'geneve', bern: 'bern', lausanne: 'lausanne', basel: 'basel', zurich: 'zurich' };
      var key = '';
      Object.keys(map).forEach(function (k) { if (pr.indexOf(k) >= 0 && !key) key = map[k]; });
      if (key) {
        var pill = root.querySelector('[data-filter="' + key + '"]');
        if (pill) filter = key, setActivePill(pill);
      }
    }
  } catch (e) {}

  function setActivePill(pill) {
    root.querySelectorAll('[data-filter]').forEach(function (p) { p.classList.toggle('is-on', p === pill); });
  }

  function matches(card) {
    if (filter === 'all') return true;
    if (filter === 'photo') return card.getAttribute('data-photo') === 'true';
    return card.getAttribute('data-model') === filter;
  }

  function apply() {
    var list = cards.filter(matches);
    if (sort === 'best') list.sort(function (a, b) { return b.getAttribute('data-rating') - a.getAttribute('data-rating') || b.getAttribute('data-ts') - a.getAttribute('data-ts'); });
    else if (sort === 'photo') list.sort(function (a, b) { return (b.getAttribute('data-photo') === 'true') - (a.getAttribute('data-photo') === 'true') || b.getAttribute('data-ts') - a.getAttribute('data-ts'); });
    else list.sort(function (a, b) { return b.getAttribute('data-ts') - a.getAttribute('data-ts'); });

    // ré-ordonner dans le DOM (garder la tuile CTA à sa place ~5e)
    var cta = grid.querySelector('.bl-avis__cta-tile');
    cards.forEach(function (c) { c.hidden = true; });
    list.forEach(function (c, i) { grid.appendChild(c); c.hidden = i >= shownCount; });
    if (cta) { if (list.length > 4) grid.insertBefore(cta, list[4].nextSibling); }

    updateMore(list.length);
  }

  var shownCount = pageSize;
  var moreBtn = root.querySelector('[data-load-more]');
  var remaining = root.querySelector('[data-remaining]');
  function updateMore(total) {
    if (!moreBtn) return;
    var left = Math.max(0, total - shownCount);
    moreBtn.parentNode.style.display = left > 0 ? '' : 'none';
    if (remaining) remaining.textContent = left;
  }

  root.querySelectorAll('[data-filter]').forEach(function (pill) {
    pill.addEventListener('click', function () { filter = pill.getAttribute('data-filter'); setActivePill(pill); shownCount = pageSize; apply(); });
  });
  var sortSel = root.querySelector('[data-sort]');
  if (sortSel) sortSel.addEventListener('change', function () { sort = sortSel.value; shownCount = pageSize; apply(); });
  if (moreBtn) moreBtn.addEventListener('click', function () { shownCount += pageSize; apply(); });

  apply();

  /* Lire plus sur les cartes longues */
  root.querySelectorAll('.bl-avis__card-text').forEach(function (txt) {
    if (txt.scrollHeight - txt.clientHeight > 4) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'bl-avis__readmore'; b.textContent = 'Lire plus';
      b.addEventListener('click', function () { var open = txt.classList.toggle('is-open'); b.textContent = open ? 'Réduire' : 'Lire plus'; });
      txt.parentNode.insertBefore(b, txt.nextSibling);
    }
  });

  /* Révéler le widget Loox (formulaire d'avis) */
  var looxWrap = root.querySelector('[data-loox-wrap]');
  var looxPrompt = root.querySelector('[data-loox-prompt]');
  function revealLoox() {
    if (looxWrap) looxWrap.hidden = false;
    if (looxPrompt) looxPrompt.hidden = true;
    // clic sur le bouton « Write a review » de Loox s'il existe
    setTimeout(function () {
      var host = root.querySelector('#looxReviews');
      if (!host) return;
      var wr = host.querySelector('.loox-write-review, [data-loox-open-form], .loox-open-write-review, button');
      if (wr && typeof wr.click === 'function') wr.click();
    }, 400);
  }
  /* Scroll vers #ecrire */
  root.querySelectorAll('[data-scroll-ecrire]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); var el = document.getElementById('ecrire'); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' }); revealLoox(); });
  });
  var openBtn = root.querySelector('[data-open-loox]');
  if (openBtn) openBtn.addEventListener('click', revealLoox);
  var toGrid = root.querySelector('[data-scroll-grid]');
  if (toGrid) toGrid.addEventListener('click', function () { grid.scrollIntoView({ behavior: 'smooth', block: 'start' }); });

  /* Le module Loox a-t-il rempli #looxReviews ? sinon garder le fallback visible */
  var looxHost2 = root.querySelector('#looxReviews');
  var fallback = root.querySelector('[data-loox-fallback]');
  if (looxHost2 && fallback) {
    setTimeout(function () { if (looxHost2.children.length > 0) fallback.hidden = true; }, 2500);
  }

  /* Lightbox photos (réutilise le style léger de la galerie produit) */
  var lb = null, items = [], idx = 0;
  function open(i) {
    items = Array.prototype.slice.call(root.querySelectorAll('[data-lightbox]'));
    idx = i;
    if (!lb) {
      lb = document.createElement('div'); lb.className = 'bl-lightbox';
      lb.innerHTML = '<img alt=""><button type="button" class="bl-lightbox__close" aria-label="Fermer">×</button><button type="button" class="bl-lightbox__nav bl-lightbox__nav--prev" aria-label="Précédent">‹</button><button type="button" class="bl-lightbox__nav bl-lightbox__nav--next" aria-label="Suivant">›</button><span class="bl-lightbox__count"></span>';
      document.body.appendChild(lb);
      lb.addEventListener('click', function (e) {
        if (e.target.closest('.bl-lightbox__nav--prev')) { idx = (idx - 1 + items.length) % items.length; render(); return; }
        if (e.target.closest('.bl-lightbox__nav--next')) { idx = (idx + 1) % items.length; render(); return; }
        if (e.target.tagName !== 'IMG') close();
      });
    }
    lb.hidden = false; document.documentElement.style.overflow = 'hidden'; render();
  }
  function render() {
    var im = lb.querySelector('img');
    im.src = items[idx].getAttribute('data-lightbox');
    var srcImg = items[idx].tagName === 'IMG' ? items[idx] : items[idx].querySelector('img');
    im.alt = srcImg ? (srcImg.alt || '') : '';
    lb.querySelector('.bl-lightbox__count').textContent = (idx + 1) + ' / ' + items.length;
  }
  function close() { if (lb) lb.hidden = true; document.documentElement.style.overflow = ''; }
  root.addEventListener('click', function (e) { var t = e.target.closest('[data-lightbox]'); if (!t) return; e.preventDefault(); var all = Array.prototype.slice.call(root.querySelectorAll('[data-lightbox]')); open(all.indexOf(t)); });
  document.addEventListener('keydown', function (e) { if (!lb || lb.hidden) return; if (e.key === 'Escape') close(); if (e.key === 'ArrowLeft') { idx = (idx - 1 + items.length) % items.length; render(); } if (e.key === 'ArrowRight') { idx = (idx + 1) % items.length; render(); } });
})();
